import { GRID_ARGS } from '../../../../utils/spds/metadata';
import Super from '../../core/container.gjs';

const METADATA = {
  component: 'Spds::Layout::Grid::Container',
  description: 'Grid container component for layout',
  meta: {
    grid: {
      ...GRID_ARGS.meta.grid,
      defaultValue: true,
    },
  },
  name: 'Grid Container',
};

export default class SpdsLayoutGridContainer extends Super {
  static metadata = this.setMetadata(METADATA);
}

export const LAYOUT_GRID_CONTAINER_METADATA = SpdsLayoutGridContainer.metadata;
